import {useEffect, useState} from "react";
import {API, CurrencyType, Endpoints} from "@brg/api";
import useAuthStateReady from "shared/hooks/useAuthStateReady";

const getFormattedPriceData = (priceData: any) => {

    let priceRouble = {
        rouble: 0,
    }
    let priceZephyr = {
        rouble: 0,
        zephyr: 0
    }
    let priceFlorin = {
        rouble: 0,
        florin: 0
    }
    let rate = 0.001

    if (priceData?.prices?.length >= 1) {
        priceRouble.rouble = priceData?.prices[0]?.parts?.find((part: any) => part?.currencyType === CurrencyType.RUB)?.amount || 0
    }
    if (priceData?.prices?.length >= 2) {
        priceZephyr.rouble = priceData?.prices[1]?.parts?.find((part: any) => part?.currencyType === CurrencyType.RUB)?.amount || 0
        priceZephyr.zephyr = priceData?.prices[1]?.parts?.find((part: any) => part?.currencyType === CurrencyType.RealMoney)?.amount || 0
    }
    if (priceData?.prices?.length >= 3) {
        priceFlorin.rouble = priceData?.prices[2]?.parts?.find((part: any) => part?.currencyType === CurrencyType.RUB)?.amount || 0
        priceFlorin.florin = priceData?.prices[2]?.parts?.find((part: any) => part?.currencyType === CurrencyType.PlayMoney)?.amount || 0
        rate = (priceData?.prices[2]?.parts?.find((part: any) => part?.currencyType === CurrencyType.PlayMoney)?.rate || 0.001).toFixed(3)
    }
    return {priceRouble, priceFlorin, priceZephyr, rate}
}

export const useGetNewBookPrice = (bookCardId?: string, time?: any) => {
    const [resp, setResp] = useState<any>(null);
    const [isLoading, setIsLoading] = useState(!!bookCardId);
    const [error, setError] = useState(false);

    useEffect(() => {

        if (!bookCardId) return;

        setIsLoading(true)
        API.request()
            .endpoint(Endpoints.economics)
            .url('/api/prices/book/v2/' + bookCardId)
            .get()
            .send()
            .then((r) => r.json())
            .then((r) => {
                setIsLoading(false)
                setResp(r)
            })
            .catch((e) => {
                setIsLoading(false)
                setError(true)
            })
    }, [bookCardId, time])


    return {resp: getFormattedPriceData(resp), isLoading, error};
}import {useEffect, useState} from "react";
import {API, CurrencyType, Endpoints} from "@brg/api";
import useAuthStateReady from "shared/hooks/useAuthStateReady";

const getFormattedPriceData = (priceData: any) => {

    let priceRouble = {
        rouble: 0,
    }
    let priceZephyr = {
        rouble: 0,
        zephyr: 0
    }
    let priceFlorin = {
        rouble: 0,
        florin: 0
    }
    let rate = 0.001

    if (priceData?.prices?.length >= 1) {
        priceRouble.rouble = priceData?.prices[0]?.parts?.find((part: any) => part?.currencyType === CurrencyType.RUB)?.amount || 0
    }
    if (priceData?.prices?.length >= 2) {
        priceZephyr.rouble = priceData?.prices[1]?.parts?.find((part: any) => part?.currencyType === CurrencyType.RUB)?.amount || 0
        priceZephyr.zephyr = priceData?.prices[1]?.parts?.find((part: any) => part?.currencyType === CurrencyType.RealMoney)?.amount || 0
    }
    if (priceData?.prices?.length >= 3) {
        priceFlorin.rouble = priceData?.prices[2]?.parts?.find((part: any) => part?.currencyType === CurrencyType.RUB)?.amount || 0
        priceFlorin.florin = priceData?.prices[2]?.parts?.find((part: any) => part?.currencyType === CurrencyType.PlayMoney)?.amount || 0
        rate = (priceData?.prices[2]?.parts?.find((part: any) => part?.currencyType === CurrencyType.PlayMoney)?.rate || 0.001).toFixed(3)
    }
    return {priceRouble, priceFlorin, priceZephyr, rate}
}

export const useGetNewBookPrice = (bookCardId?: string, time?: any) => {
    const [resp, setResp] = useState<any>(null);
    const [isLoading, setIsLoading] = useState(!!bookCardId);
    const [error, setError] = useState(false);

    useEffect(() => {

        if (!bookCardId) return;

        setIsLoading(true)
        API.request()
            .endpoint(Endpoints.economics)
            .url('/api/prices/book/v2/' + bookCardId)
            .get()
            .send()
            .then((r) => r.json())
            .then((r) => {
                setIsLoading(false)
                setResp(r)
            })
            .catch((e) => {
                setIsLoading(false)
                setError(true)
            })
    }, [bookCardId, time])


    return {resp: getFormattedPriceData(resp), isLoading, error};
}